import React from "react";
import { FaCheckCircle, FaHeart } from "react-icons/fa";

export default function Thankyou() {
  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-50 to-gray-100">
      <div className="flex flex-col justify-center items-center min-h-screen py-6 px-4">
        <div className="w-full max-w-md bg-white rounded-2xl shadow-xl shadow-gray-200/50 overflow-hidden">
          <div className="bg-gradient-to-r from-green-400 to-emerald-500 px-6 py-5 text-white">
            <h1 className="text-xl font-semibold text-center">All Done!</h1>
          </div>

          <div className="p-6 text-center">
            <div className="flex justify-center mb-4">
              <div className="relative">
                <div className="w-20 h-20 bg-green-50 rounded-full flex items-center justify-center">
                  <FaCheckCircle className="text-green-500 text-4xl" />
                </div>

                <div className="absolute inset-0 w-20 h-20 bg-green-200 rounded-full animate-ping opacity-20" />
              </div>
            </div>

            <h2 className="text-2xl font-bold text-gray-800 mb-2">
              Thank You!
            </h2>
            <p className="text-gray-600 mb-4">
              We appreciate you taking the time to share your feedback with us.
            </p>

            <div className="bg-gradient-to-r from-pink-50 to-red-50 rounded-xl p-4 mb-4">
              <div className="flex items-center justify-center gap-2 text-gray-700">
                <span className="font-medium">
                  Your feedback helps us improve!
                </span>
              </div>
            </div>
          </div>
        </div>

        <p className="text-gray-400 text-sm mt-6">
          You may close this page now
        </p>
      </div>
    </div>
  );
}
